export function ownerDocumentOpenQueryKey(documentId: string | null) {
  return ["document", documentId, "open"] as const;
}

export function translationDocumentQueryKey(documentId: string) {
  return ["translation", documentId] as const;
}
export function translationWorkspaceQueryKey(documentId: string, versionNumber: number) {
  return [...translationDocumentQueryKey(documentId), versionNumber, "workspace"] as const;
}
export function translationCurrentProcessQueryKey(documentId: string, versionNumber: number) {
  return [...translationDocumentQueryKey(documentId), versionNumber, "current-process"] as const;
}
export function translationEditionsQueryKey(documentId: string, versionNumber: number) {
  return [...translationDocumentQueryKey(documentId), versionNumber, "editions"] as const;
}
